import { useSyncExternalStore } from 'react'
import RegionService from '../service/RegionService'

// Stable references, so useSyncExternalStore doesn't resubscribe on every render
const subscribe = (listener: () => void) => RegionService.subscribe(listener)
const getRegion = () => RegionService.get()

export default function useRegion(): string {
    return useSyncExternalStore(subscribe, getRegion)
}
